"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclTranslationsDe = void 0;
exports.aclTranslationsDe = {
    // ACL Resources
    'acl_resource.company': 'Unternehmen',
    'acl_resource.user': 'Benutzer',
    'acl_resource.user_group': 'Benutzergruppe',
    'acl_resource.settings_general': 'Allgemeine Einstellungen',
    'acl_resource.settings_access': 'Zugriffs-Einstellungen',
    'acl_resource.settings_styles': 'Stil-Einstellungen',
    'acl_resource.avatar': 'Avatar',
    'acl_resource.ai': 'KI',
    'acl_resource.knowledge': 'Wissen',
    'acl_resource.project': 'Projekt',
    'acl_resource.onboarding': 'Einarbeitung',
    'acl_resource.reports': 'Berichte',
    // ACL Actions
    'acl_action.read': 'Lesen',
    'acl_action.write': 'Schreiben',
    'acl_action.delete': 'Löschen',
};
